import React, { useState, useRef } from "react";
import SectionHeading from "./sectionHeading";
import ContainerCard from "./containerCard";
import { Button, Input } from "@speedoc/design-assets";
import sendEmail from "../../utils/sendEmail";
import { trackCustom } from "../../services/analytics";
import SubmissionConfirmation from "./submissionConfirmation";
import { GlobalStore } from "../../stores/global";

function FormBulletList({ item }) {
  return (
    <div className="bulletList">
      <span className="circle" /> <p>{item.text}</p>
    </div>
  );
}

export default function ContactForm({ content }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formHeight, setFormHeight] = useState(undefined);
  const targetRef = useRef();
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const [error, setError] = useState(false);

  const isChromeOrFirefox = () => {
    const operaAgent = navigator.userAgent.indexOf(" OPR/") > -1;
    const safariAgent =
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent.indexOf("CriOS") === -1 &&
      navigator.userAgent.indexOf("FxiOS") === -1;
    return operaAgent === false && safariAgent === false;
  };

  const initialState = {
    name: "",
    email: "",
    nric: "",
    phone: ""
  };

  const [formData, setFormData] = useState(initialState);

  const handleInputChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (formData.email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)) {
      try {
        await sendEmail(formData, content.formInfo);
        setFormHeight(targetRef.current.offsetHeight);
      } catch (err) {
        console.log(err);
      } finally {
        trackCustom("Lead", countryCode, { email: formData.email });
        setError(false);
        setIsSubmitting(false);
        setIsSubmitted(true);
        setFormData({ ...initialState });
      }
    } else {
      setError("Please enter a valid email.");
      setIsSubmitting(false);
    }
  };

  const handleBackClick = () => {
    setIsSubmitted(false);
  };

  return (
    <div className="contactForm" id="contactFormAnchor">
      <SectionHeading title={content.title} />
      <ContainerCard>
        {!isSubmitted ? (
          <div className="container" ref={targetRef}>
            <div className="textSection">
              <div className="listItems">
                {content.list.map((item, i) => (
                  <FormBulletList item={item} key={i} />
                ))}
              </div>
            </div>
            <form className="formSection" onSubmit={handleSubmit}>
              <Input
                className={`sm ${isChromeOrFirefox() ? "" : "margin-bottom"}`}
                id="contactForm-Name"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleInputChange}
              />
              <Input
                className="sm"
                name="nric"
                id="contactForm-nric"
                placeholder="NRIC"
                value={formData.nric}
                onChange={handleInputChange}
              />
              <Input
                className={`sm ${error && error.includes("email") ? "error" : ""}`}
                id="email"
                type="email"
                name="email"
                required
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
              />
              <Input
                className="sm"
                id="contactForm-phone"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </form>
            <div className="buttonSection">
              <Button onClick={handleSubmit} disabled={isSubmitting} className="primary sm">
                {isSubmitting ? "Please wait..." : content.buttonText}
              </Button>
              {error ? <p className="errorMessage">{error}</p> : null}
            </div>
          </div>
        ) : (
          <SubmissionConfirmation formHeight={formHeight} handleBackClick={handleBackClick} />
        )}
      </ContainerCard>
    </div>
  );
}
